import { render } from "./GlobalAlert.vue?vue&type=template&id=47798856&ts=true"
import script from "./GlobalAlert.vue?vue&type=script&lang=ts"
export * from "./GlobalAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/pablo/Sites/buen-provecho-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__